import React, { Component } from 'react';
import { Button, Modal, Col, Badge } from 'react-bootstrap'
import api from '../../services/api';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);


class ModalImpressao extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: '',
            dados: '',
            semRelatorio: '',
            carregando: '',
            mensagem: ''
        }
    }


    componentDidMount() {
        this.setState({ show: false, semRelatorio: false, tipoMensagem: "", carregando: false });
    }


    getRelatorio = async () => {

        let config = {
            headers: {
                'IDMOV': this.props.idmov,
            }
        }


        try {

            this.setState({ carregando: true, mensagem: "" });


            const response = await api.get('/RelatorioMedicaoObras', config);
            this.setState({ dados: response.data.arquivo });

            switch (response.data.status) {

                case "0":
                    this.setState({ mensagem: "Sem dados de relatório", semRelatorio: true, tipoMensagem: "primary", carregando: false });
                    break;

                case "1":
                    this.setState({ dados: response.data.arquivo, tipoMensagem: "", carregando: false });
                    this.handleShow();
                    break;

                default:
                    this.setState({ mensagem: "Erro ao gerar relatório!", tipoMensagem: "danger", carregando: false });
            }

        }
        catch (err) {
            this.setState({ mensagem: 'Erro ao carregar o relatório!', tipoMensagem: "danger", carregando: false })
        }

    }


    handleShow = () => this.setState({ show: true });
    handleClose = () => this.setState({ show: false });

    handleDownload = () => {

        let base64str = this.state.dados;

        var binary = atob(base64str.replace(/\s/g, ''));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);

        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }

        var blob = new Blob([view], { type: 'application/pdf' });

        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement('a');
        a.href = fileURL;
        a.target = "_blank";
        a.download = `medicao-${this.props.idmov}.pdf`;
        document.body.appendChild(a);
        a.click();

    }


    render() {
        return (
            this.props.visible === true ?
                <Col className="text-right">

                    <Badge variant={this.state.tipoMensagem} className="mr-2">
                        {this.state.mensagem}
                    </Badge>{' '}

                    <Button variant="light" onClick={this.getRelatorio} disabled={this.props.disabled} data-placement="right" title="Imprimir Medição">
                        {this.state.carregando !== true ?
                            <FontAwesomeIcon icon="print" />
                            :
                            <>
                                <FontAwesomeIcon icon="sync-alt" className="mr-2" />
                            Carregando...
                        </>
                        }
                    </Button>

                    <Modal
                        show={this.state.show}
                        onHide={this.handleClose}
                        size="lg"
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Visualizar Medição</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <iframe id="iframePdf" title={`medição-${this.props.idmov}`} src={`data:application/pdf;base64,${this.state.dados}`}
                                style={{ width: '100%', height: '400px' }} />
                        </Modal.Body>
                        <Modal.Footer>

                            <Button variant="light" onClick={this.handleDownload}>
                                <FontAwesomeIcon icon="file-download" className="mr-2" />
                                    Fazer Download em PDF
                            </Button>

                            <Button variant="primary" onClick={this.handleClose}>Fechar</Button>

                        </Modal.Footer>
                    </Modal>
                </Col>
                :
                <></>
        );
    }
}

export default ModalImpressao;